<div id="print-maintance-round">
  <div class="page">
    <header>
      <h1 class="print">{{ 'report.new.list.maintanceRound' | translate }}</h1>
      <h2>{{ report().description | translate }}</h2>
      <h2>{{ report().made| timestamp:'d.M.yyyy' }}</h2>
      @if (site().image) {
        <div class="print">
          <img [src]="site().image" />
        </div>
      }
    </header>
  </div>
  <div class="page">
    <h3>{{ report().description | translate }}</h3>
    <table>
      <tr class="header">
        <td colspan="3">{{ 'home.renovation.participants' | translate }}</td>
      </tr>
      @for (user of report().participants; track $index) {
        <tr>
          <td>
            {{ user.name }}
          </td>
          <td>
            @if (user.company) {
              {{ user.company }}<br />
            }
            {{ user.role }}
          </td>
          <td>
            {{ user.email }}
          </td>
        </tr>
      }
    </table>
    <h4>
      {{ 'report.maintanceRound.basic' | translate }}
    </h4>
    <table>
      <tr class="header">
        <td>{{ 'report.maintanceRound.siteName' | translate }}</td>
        <td>{{ 'report.maintanceRound.siteAddress' | translate }}</td>
      </tr>
      <tr>
        <td>{{ site().name }}</td>
        <td>{{ site().streetAddress }}, {{ site().postalCode }} {{ site().city }}</td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.orderDate' | translate }}</td>
        <td>{{ 'report.maintanceRound.made' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().orderDate | timestamp:'d.M.yyyy' }}</td>
        <td>{{ report().made | timestamp:'d.M.yyyy' }}</td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.distribution' | translate }}</td>
        <td>{{ 'report.maintanceRound.conditionChecked' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().distribution }}</td>
        <td>
          <ng-container [ngTemplateOutlet]="booleanTemplate"
            [ngTemplateOutletContext]="{ value: report().conditionChecked }">
          </ng-container>
        </td>
      </tr>
      <tr class="header">
        <td colspan="2">{{ 'report.maintanceRound.hopes' | translate }}</td>
      </tr>
      <tr>
        <td colspan="2">{{ report().hopes }}</td>
      </tr>
      <tr class="header">
        <td colspan="2">{{ 'report.maintanceRound.fixHistory' | translate }}</td>
      </tr>
      <tr>
        <td colspan="2">{{ report().fixHistory }}</td>
      </tr>
      <tr class="header">
        <td colspan="2">{{ 'report.maintanceRound.other' | translate }}</td>
      </tr>
      <tr>
        <td colspan="2">{{ report().other }}</td>
      </tr>
    </table>
  </div>
  <div class="page">
    <h3>{{ 'report.apartmentRound.summary' | translate }}</h3>
    <table>
      <tr class="header">
        <td>{{ 'report.maintanceRound.observations' | translate }}</td>
      </tr>
      <tr>
        <td>
          <pre>{{ report().observations }}</pre>
        </td>
      </tr>
    </table>
  </div>
  <div class="page">
    <table>
      <tr class="header">
        <td colspan="2">{{ 'report.maintanceRound.proposals' | translate }}</td>
      </tr>
      <tr>
        <td colspan="2">
          <pre>{{ report().proposals }}</pre>
        </td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.willOrder' | translate }}</td>
        <td>{{ 'report.maintanceRound.addition' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().willOrder }}</td>
        <td>{{ report().addition }}</td>
      </tr>
    </table>
  </div>
  <div class="page">
    <h3>{{ 'report.maintanceRound.propertyInformation' | translate }}</h3>
    <table>
      <tr class="header">
        <td>{{ 'report.maintanceRound.maintance' | translate }}</td>
        <td>{{ 'report.maintanceRound.cleaning' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().maintance }}</td>
        <td>{{ report().cleaning }}</td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.buildingType' | translate }}</td>
        <td>{{ 'report.maintanceRound.built' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().buildingType }}</td>
        <td>{{ report().built }}</td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.floors' | translate }}</td>
        <td>{{ 'report.maintanceRound.apartments' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().floors }}</td>
        <td>{{ report().apartments }}</td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.blocks' | translate }}</td>
        <td>{{ 'report.maintanceRound.buildingMaterial' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().blocks }}</td>
        <td>{{ report().buildingMaterial }}</td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.roofType' | translate }}</td>
        <td>{{ 'report.maintanceRound.heating' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().roofType }}</td>
        <td>{{ report().heating }}</td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.pumps' | translate }}</td>
        <td>{{ 'report.maintanceRound.heatingCenter' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().pumps }}</td>
        <td>{{ report().heatingCenter }}</td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.smokeExit' | translate }}</td>
        <td>{{ 'report.maintanceRound.electricityMain' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().smokeExit }}</td>
        <td>{{ report().electricityMain }}</td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.air' | translate }}</td>
        <td>{{ 'report.maintanceRound.firePrevention' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().air }}</td>
        <td>{{ report().firePrevention }}</td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.emergencyStop' | translate }}</td>
        <td>{{ 'report.maintanceRound.waterOff' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().emergencyStop }}</td>
        <td>{{ report().waterOff }}</td>
      </tr>
    </table>
  </div>
  <div class="page">
    <h3>{{ 'report.maintanceRound.outdoors' | translate }}</h3>
    <table>
      <tr class="header">
        <td>{{ 'report.maintanceRound.waste' | translate }}</td>
        <td>{{ 'report.maintanceRound.yard' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().waste }}</td>
        <td>{{ report().yard }}</td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.rain' | translate }}</td>
        <td>{{ 'report.maintanceRound.yardEquipment' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().rain }}</td>
        <td>{{ report().yardEquipment }}</td>
      </tr>
      <tr class="header">
        <td colspan="2">{{ 'report.maintanceRound.outdoorOther' | translate }}</td>
      </tr>
      <tr>
        <td colspan="2">{{ report().outdoorOther }}</td>
      </tr>
    </table>
    <div class="flex">
      @for (image of report().outdoorImages; track $index) {
        <img [src]="image"
          class="review-image" />
      }
    </div>
  </div>
  <div class="page">
    <h3>{{ 'report.maintanceRound.front' | translate }}</h3>
    <table>
      <tr class="header">
        <td>{{ 'report.maintanceRound.seams' | translate }}</td>
        <td>{{ 'report.maintanceRound.windows' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().seams }}</td>
        <td>{{ report().windows }}</td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.plinths' | translate }}</td>
        <td>{{ 'report.maintanceRound.tins' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().plinths }}</td>
        <td>{{ report().tins }}</td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.feedThroughs' | translate }}</td>
        <td>{{ 'report.maintanceRound.frontOther' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().feedThroughs }}</td>
        <td>{{ report().frontOther }}</td>
      </tr>
    </table>
    <div class="flex">
      @for (image of report().frontImages; track $index) {
        <img [src]="image"
          class="review-image" />
      }
    </div>
  </div>
  <div class="page">
    <h3>{{ 'report.maintanceRound.commonAreas' | translate }}</h3>
    <table>
      <tr class="header">
        <td>{{ 'report.maintanceRound.structures' | translate }}</td>
        <td>{{ 'report.maintanceRound.saunas' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().structures }}</td>
        <td>{{ report().saunas }}</td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.waterBlocks' | translate }}</td>
        <td>{{ 'report.maintanceRound.lifts' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().waterBlocks }}</td>
        <td>{{ report().lifts }}</td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.civilDefence' | translate }}</td>
        <td>{{ 'report.maintanceRound.washRoom' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().civilDefence }}</td>
        <td>{{ report().washRoom }}</td>
      </tr>
      <tr class="header">
        <td colspan="2">{{ 'report.maintanceRound.commonOther' | translate }}</td>
      </tr>
      <tr>
        <td colspan="2">{{ report().commonOther }}</td>
      </tr>
    </table>
  </div>
  <div class="page">
    <h3>{{ 'report.maintanceRound.roofing' | translate }}</h3>
    <table>
      <tr class="header">
        <td>{{ 'report.maintanceRound.waterExit' | translate }}</td>
        <td>{{ 'report.maintanceRound.upperFloor' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().waterExit }}</td>
        <td>{{ report().upperFloor }}</td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.entrance' | translate }}</td>
        <td>{{ 'report.maintanceRound.cleaniness' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().entrance }}</td>
        <td>{{ report().cleaniness }}</td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.safetyEquipment' | translate }}</td>
        <td>{{ 'report.maintanceRound.roofingOther' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().safetyEquipment }}</td>
        <td>{{ report().roofingOther }}</td>
      </tr>
    </table>
  </div>
  <div class="page">
    <h3>{{ 'report.maintanceRound.apartments' | translate }}</h3>
    @for (area of report().apartmentItems; track $index) {
      <table>
        <tr class="header">
          <td>{{ 'report.maintanceRound.apartment' | translate }}</td>
          <td>{{ 'report.maintanceRound.apartmentObservation' | translate }}</td>
        </tr>
        <tr>
          <td>{{ area.name }}</td>
          <td>{{ area.observations }}</td>
        </tr>
      </table>
      <div class="flex">
        @for (image of area.images; track $index) {
          <img [src]="image"
            class="review-image" />
        }
      </div>
    }
  </div>
  <div class="page">
    <h3>{{ 'report.maintanceRound.documents' | translate }}</h3>
    <table>
      <tr class="header">
        <td>{{ 'report.maintanceRound.maintanceContract' | translate }}</td>
        <td>{{ 'report.maintanceRound.map' | translate }}</td>
      </tr>
      <tr>
        <td>
          <ng-container [ngTemplateOutlet]="booleanTemplate"
            [ngTemplateOutletContext]="{ value: report().maintanceContract }">
          </ng-container>
        </td>
        <td>
          <ng-container [ngTemplateOutlet]="booleanTemplate"
            [ngTemplateOutletContext]="{ value: report().map }">
          </ng-container>
        </td>
      </tr>
      <tr class="header">
        <td>{{ 'report.maintanceRound.maintanceHistory' | translate }}</td>
        <td>{{ 'report.maintanceRound.documentsOther' | translate }}</td>
      </tr>
      <tr>
        <td>
          <ng-container [ngTemplateOutlet]="booleanTemplate"
            [ngTemplateOutletContext]="{ value: report().maintanceHistory }">
          </ng-container>
        </td>
        <td>
          {{ report().documentsOther }}
        </td>
      </tr>
    </table>
  </div>
  <div class="page">
    <p>{{ 'report.maintanceRound.attachment' | translate }}</p>
    <pre>{{ report().attachment }}</pre>
  </div>
</div>
<ng-template #booleanTemplate
  let-value="value">
  @if (value) {
    <ion-icon color="success"
      name="checkmark-outline"></ion-icon>
  } @else {
    <ion-icon color="danger"
      name="close-outline"></ion-icon>
  }
</ng-template>